import { Inspector } from '@react-email/editor/ui';
import { useCallback, useState } from 'react';
import styled from 'styled-components';

import { ConditionalLogicPanel } from './ConditionalLogicPanel';
import { DataReferencePanel } from './DataReferencePanel';
import { GlobalProperties } from './inspector/GlobalProperties';
import { InspectorBreadcrumb } from './inspector/InspectorBreadcrumb';
import { NodeProperties } from './inspector/NodeProperties';
import { TextProperties } from './inspector/TextProperties';

interface Props {
	variables: string[];
	onInsert: (token: string) => void;
	backgroundColor: string;
	onBackgroundColorChange: (value: string) => void;
}

const BreadcrumbBar = styled.div`
	padding: 0.75rem 1rem;
	border-bottom: 1px solid var(--mantine-color-gray-4);
`;

export const EmailTemplateInspectorPanel = ({
	variables,
	onInsert,
	backgroundColor,
	onBackgroundColorChange,
}: Props) => {
	const [customColors, setCustomColors] = useState<string[]>([]);
	const addCustomColor = useCallback((hex: string) => {
		setCustomColors((previous) => {
			const normalized = hex.toLowerCase();
			return [hex, ...previous.filter((color) => color.toLowerCase() !== normalized)].slice(
				0,
				6
			);
		});
	}, []);

	return (
		<>
			<Inspector.Root>
				<BreadcrumbBar>
					<InspectorBreadcrumb />
				</BreadcrumbBar>
				<GlobalProperties
					customColors={customColors}
					onCustomColorUsed={addCustomColor}
					backgroundColor={backgroundColor}
					onBackgroundColorChange={onBackgroundColorChange}
				/>
				<NodeProperties customColors={customColors} onCustomColorUsed={addCustomColor} />
				<TextProperties customColors={customColors} onCustomColorUsed={addCustomColor} />

				{/* Inside Inspector.Root: its focus scope keeps the editor selection
				    alive while a control in this panel is clicked. */}
				<ConditionalLogicPanel />
				<DataReferencePanel variables={variables} onInsert={onInsert} />
			</Inspector.Root>
		</>
	);
};
